import { frontendURL } from '../../../helper/URLHelper';
import store from 'dashboard/store';
import { REDIS_FEATURE_FLAGS } from 'dashboard/featureFlags';

const ClaudiaLayout = () => import('./components/ClaudiaLayout.vue');
const EddieView = () => import('../eddie/pages/EddieView.vue');
const KnowledgeBaseMicrofrontend = () =>
  import(
    '../../../../microfrontends/knowledge-base/KnowledgeBaseMicrofrontend.vue'
  );
const ClaudiaAgentsView = () => import('./pages/ClaudiaAgentsView.vue');
const ClaudiaToolsView = () => import('./pages/ClaudiaToolsView.vue');
const ClaudiaMcpView = () => import('./pages/ClaudiaMcpView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/claudia'),
      name: 'claudia_app',
      component: ClaudiaLayout,
      meta: {
        permissions: ['administrator', 'cx_engineer'],
      },
      children: [
        {
          path: '',
          name: 'claudia_default',
          // Match parent's permissions so the global beforeEach guard's
          // `routeIsAccessibleFor` check passes for admins/cx_engineers.
          // Without this meta the empty child has no permissions array and
          // the legacy `validateLoggedInRoutes` redirects to /dashboard
          // before our beforeEnter ever fires.
          meta: { permissions: ['administrator', 'cx_engineer'] },
          beforeEnter: (to, from, next) => {
            const { accountId } = to.params;
            const claudiaOnly = store.getters[
              'accounts/isFeatureEnabledonAccount'
            ](Number(accountId), REDIS_FEATURE_FLAGS.CLAUDIA_ONLY);
            // Use absolute path: the name `eddie_view` is duplicated between
            // claudia.routes.js and eddie.routes.js, so name-based redirect
            // resolves to the wrong route under Vue Router 3.
            const target = claudiaOnly ? 'agents' : 'view';
            next(frontendURL(`accounts/${accountId}/claudia/${target}`));
          },
        },
        {
          path: 'view',
          name: 'eddie_view',
          component: EddieView,
          meta: { permissions: ['administrator', 'cx_engineer'] },
        },
        {
          path: 'knowledge-bases',
          name: 'knowledge_base_view',
          component: KnowledgeBaseMicrofrontend,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
            newFeatureFlag: 'enable_knowledge_bases',
          },
        },
        {
          path: 'knowledge-bases/*',
          name: 'knowledge_base_view_catchall',
          component: KnowledgeBaseMicrofrontend,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
            newFeatureFlag: 'enable_knowledge_bases',
          },
        },
        {
          path: 'agents',
          name: 'claudia_agents',
          component: ClaudiaAgentsView,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
          },
        },
        {
          path: 'tools',
          name: 'claudia_tools',
          component: ClaudiaToolsView,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
          },
        },
        {
          path: 'mcp',
          name: 'claudia_mcp',
          component: ClaudiaMcpView,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
          },
        },
      ],
    },
  ],
};
